"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CinFinGarageTypeEnum = exports.CinFinRoofGeometryTypeEnum = exports.CinFinRoofMaterialTypeEnum = exports.CinFinConstructionTypeEnum = exports.CinFinFoundationTypeEnum = void 0;
var CinFinFoundationTypeEnum;
(function (CinFinFoundationTypeEnum) {
    CinFinFoundationTypeEnum["slab"] = "Slab";
    CinFinFoundationTypeEnum["basement"] = "BS";
})(CinFinFoundationTypeEnum || (exports.CinFinFoundationTypeEnum = CinFinFoundationTypeEnum = {}));
var CinFinConstructionTypeEnum;
(function (CinFinConstructionTypeEnum) {
    CinFinConstructionTypeEnum["pouredConcrete"] = "Pconcrete";
    CinFinConstructionTypeEnum["wood"] = "F";
    CinFinConstructionTypeEnum["masonry"] = "MY";
    CinFinConstructionTypeEnum["steelOrMetal"] = "Steel";
    CinFinConstructionTypeEnum["log"] = "L";
})(CinFinConstructionTypeEnum || (exports.CinFinConstructionTypeEnum = CinFinConstructionTypeEnum = {}));
var CinFinRoofMaterialTypeEnum;
(function (CinFinRoofMaterialTypeEnum) {
    CinFinRoofMaterialTypeEnum["architecturalShingles"] = "ARCH";
    CinFinRoofMaterialTypeEnum["asphaltShingles"] = "ASPHS";
    CinFinRoofMaterialTypeEnum["clayTile"] = "CLAY";
    CinFinRoofMaterialTypeEnum["composition"] = "COMPW";
    CinFinRoofMaterialTypeEnum["metal"] = "METL";
    CinFinRoofMaterialTypeEnum["slate"] = "SLAT";
    CinFinRoofMaterialTypeEnum["tarAndGravel"] = "TARGRB";
    CinFinRoofMaterialTypeEnum["wood"] = "WOODSS";
})(CinFinRoofMaterialTypeEnum || (exports.CinFinRoofMaterialTypeEnum = CinFinRoofMaterialTypeEnum = {}));
var CinFinRoofGeometryTypeEnum;
(function (CinFinRoofGeometryTypeEnum) {
    CinFinRoofGeometryTypeEnum["gable"] = "GABLE";
    CinFinRoofGeometryTypeEnum["complex"] = "COMPLEX";
    CinFinRoofGeometryTypeEnum["flat"] = "FLAT";
    CinFinRoofGeometryTypeEnum["gambrel"] = "GAMBREL";
    CinFinRoofGeometryTypeEnum["hip"] = "HIP";
    CinFinRoofGeometryTypeEnum["shed"] = "SHED";
})(CinFinRoofGeometryTypeEnum || (exports.CinFinRoofGeometryTypeEnum = CinFinRoofGeometryTypeEnum = {}));
var CinFinGarageTypeEnum;
(function (CinFinGarageTypeEnum) {
    CinFinGarageTypeEnum["frame"] = "Frame";
    CinFinGarageTypeEnum["basement"] = "BS";
    CinFinGarageTypeEnum["builtIn"] = "BI";
})(CinFinGarageTypeEnum || (exports.CinFinGarageTypeEnum = CinFinGarageTypeEnum = {}));
